import React from 'react';
import Modal from '@ui-components/Modal';

interface ValidateDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isValidating: boolean;
  gameInfo?: string;
  anomalyDescription?: string;
}

export const ValidateDocumentModal: React.FC<ValidateDocumentModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isValidating,
  gameInfo,
  anomalyDescription
}) => {
  return (
    <Modal
      title="Valida Referto"
      opened={isOpen}
      onExit={onClose}
      maxWidth="w-full sm:max-w-md"
    >
      <div className="space-y-4">
        {gameInfo && (
          <p className="text-sm text-gray-600 font-medium">Gara: {gameInfo}</p>
        )}
        
        {anomalyDescription && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <p className="text-xs font-medium text-yellow-800 mb-1">Anomalia precedente:</p>
            <p className="text-sm text-yellow-700">{anomalyDescription}</p>
          </div>
        )}
        
        <p className="text-sm text-gray-700">
          Confermi che il nuovo referto caricato è corretto? La segnalazione di anomalia verrà rimossa.
        </p>
        
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            disabled={isValidating}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Annulla
          </button>
          <button
            onClick={onConfirm}
            disabled={isValidating}
            className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
          >
            {isValidating ? (
              <>
                <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Validazione...
              </>
            ) : (
              'Valida Referto'
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};
